<script setup>
import Quantity from "./Quantity.vue";
import Switcher from "./Switcher.vue";

const props = defineProps(['id', 'label', 'options', 'subattributes'])
const value = defineModel('value')
const length = defineModel('length')
</script>

<template>
    <Switcher :id="id" :label="label" :options="options" v-model="value" />
    <Quantity v-if="subattributes.length && 'per_metre' === value.id" :id="`${id}-length`" :label="subattributes.length.label" :min="subattributes.length.min" :step="subattributes.length.step" :max="subattributes.length.max" :unit="subattributes.length.unit" :display-multiplier="subattributes.length['display_multiplier']" v-model="length" />
    
    <p v-if="value.message" v-html="value.message" class="message"></p>
</template>
